'use strict';

module.exports = (element, index) => element;